import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Topbar from '../components/layout/Topbar';
import { Panel, PanelHead, PanelBody, Button } from '../components/ui';
import { useWindowSize } from '../hooks/useWindowSize';

// Questa pagina è stata deprecata.
//
// I dati che salvava (beach.disponibilita, beach.prezzi) erano campi legacy
// del documento radice del lido e non venivano letti né dal sistema di prenotazione
// né dall'app mobile. Le funzionalità equivalenti sono ora in:
//
//   • Capacità posti per area → Servizi (campo capacitaMax)
//   • Prezzi giornalieri       → Tariffe (sottocollezione tariffe/)
//   • Layout fisico spiaggia   → Beach Builder

export default function Availability() {
  const { beach } = useAuth();
  const { isMobile } = useWindowSize();
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Topbar title="Disponibilità & Prezzi" />

      <div style={{ padding: isMobile ? '12px 16px' : '24px 28px', overflowY: 'auto', flex: 1 }}>
        <Panel style={{ marginBottom: '16px', border: '1px solid rgba(245,200,66,0.4)' }}>
          <PanelBody style={{ padding: '20px 24px' }}>
            <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
              <div style={{ fontSize: '22px', flexShrink: 0 }}>⚠️</div>
              <div>
                <div style={{ fontSize: '14px', fontWeight: 500, marginBottom: '8px', color: 'var(--sand)' }}>
                  Questa sezione non è più in uso
                </div>
                <p style={{ fontSize: '13px', color: 'var(--text-soft)', lineHeight: 1.6, margin: 0 }}>
                  I campi che questa pagina salvava (<code>disponibilita</code>, <code>prezzi</code>)
                  erano dati legacy non collegati al sistema di prenotazione e mai letti dall'app.
                </p>
                <p style={{ fontSize: '13px', color: 'var(--text-soft)', lineHeight: 1.6, margin: '10px 0 0' }}>
                  Usa invece:
                </p>
                <ul style={{ fontSize: '13px', color: 'var(--text-soft)', lineHeight: 1.8, margin: '6px 0 0', paddingLeft: '20px' }}>
                  <li><strong>Servizi</strong> → campo <em>Capienza massima</em> per le aree lettini</li>
                  <li><strong>Tariffe</strong> → prezzi giornalieri per tipo di posto</li>
                  <li><strong>Beach Builder</strong> → layout fisico e numero di posti prenotabili</li>
                </ul>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '20px', flexWrap: 'wrap' }}>
              <Button variant="primary" onClick={() => navigate('/servizi')}>
                Vai a Servizi →
              </Button>
              <Button variant="ghost" onClick={() => navigate('/tariffe')}>
                Vai a Tariffe →
              </Button>
              <Button variant="ghost" onClick={() => navigate('/beach-builder')}>
                Vai a Beach Builder →
              </Button>
            </div>
          </PanelBody>
        </Panel>

        <Panel>
          <PanelHead title="Servizi configurati" subtitle="Riepilogo — modifica in Servizi" />
          <PanelBody>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {(beach?.servizi || []).map((s, i) => (
                <div key={i} style={{
                  padding: '5px 14px', borderRadius: '20px',
                  background: 'var(--surface)', border: '1px solid var(--border)',
                  fontSize: '12.5px', color: 'var(--text-soft)',
                }}>
                  {s.icona || ''} {s.label || s}
                </div>
              ))}
              {(!beach?.servizi?.length) && (
                <span style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
                  Nessun servizio configurato.
                </span>
              )}
            </div>
          </PanelBody>
        </Panel>
      </div>
    </div>
  );
}
